import { IconClear, useClassnames } from '@wb-tech/ui-react';
import React from 'react';

import style from './index.module.pcss';

export const CloseIcon = () => {
    const cn = useClassnames(style);

    return (
        <IconClear
            svg={{
                className: cn('notification-icon')
            }}
        />
    );
};
